import { IconFileText } from 'central-icons/IconFileText';
import type { ComponentType } from 'react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';

import { useGetLoggedInUser } from '@revelio/auth';
import { Tab } from '@revelio/data-access';

import taxonomyCatalogIcon from '../../../../images/icons/taxonomy-catalog-icon.svg';

type MethodologyMenuItemBase = {
  id: string;
  children: string;
  onClick: () => void;
};

export type MethodologyMenuItem = MethodologyMenuItemBase &
  (
    | { icon: ComponentType<{ size?: number | string }>; iconSrc?: never }
    | { icon?: never; iconSrc: string }
  );

export const useMethodologyMenuItems = () => {
  const navigate = useNavigate();
  const { loggedInUser } = useGetLoggedInUser();
  const { tabs } = loggedInUser;
  const menuItems = useMemo(() => {
    const items: MethodologyMenuItem[] = [];
    if (tabs?.includes(Tab.DataDictionary)) {
      items.push({
        id: 'data-dictionary',
        icon: IconFileText,
        children: 'Data Dictionary',
        onClick: () => navigate('/data-dictionary'),
      });
    }

    /* Taxonomy Catalog is enabled for everyone */
    items.push({
      id: 'taxonomy-catalog',
      iconSrc: taxonomyCatalogIcon,
      children: 'Taxonomy Catalog',
      onClick: () => navigate('/taxonomy-catalog'),
    });
    return items;
  }, [navigate, tabs]);

  return {
    showMenu: menuItems.length > 0,
    menuItems,
  };
};
